var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.textBlocks),function(textBlock){return _c('ListItem',{key:textBlock.id,attrs:{"text-block":textBlock,"shared":_vm.shared}})}),_vm._v(" "),(!_vm.textBlocks.length)?_c('span',[_vm._v(" "+_vm._s(_vm.t('mail', 'No text blocks available'))+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }